import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { COPY } from '../../i18n/copy';
import { useI18n } from '../../i18n/useI18n';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const { lang } = useI18n();
  const c = COPY[lang];
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAcceptedCookies = localStorage.getItem('cookiesAccepted');
    if (!hasAcceptedCookies) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 100, damping: 20 }}
          className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-gray-200 shadow-lg"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex-1">
                <p className="text-gray-600">
                  {c.cookie.message}{' '}
                  <Link
                    to="/privacy"
                    className="text-[#14b5bd] hover:text-[#14b5bd]/80 underline"
                    onClick={() => setIsVisible(false)}
                  >
                    {c.cookie.learnMore}
                  </Link>
                </p>
              </div>
              <div className="flex items-center gap-4">
                <button
                  onClick={acceptCookies}
                  className="px-6 py-2 bg-[#14b5bd] text-white rounded-full font-semibold hover:bg-[#14b5bd]/90 transition-colors duration-300"
                >
                  {c.cookie.accept}
                </button>
                <button
                  onClick={() => setIsVisible(false)}
                  className="p-2 text-gray-400 hover:text-gray-600 transition-colors duration-300"
                  aria-label={c.cookie.close}
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
